import CHATED from '../../../helpers/chated-client';
import {
	ACTIVATE_PAYMENT,
	ERROR_ACTIVATE_PAYMENT
} from '../../../constants';

export function activatePayment(queryObject) {
	return async (dispatch) => {
		const response = await CHATED.payment.activateShopifyAbandonedCartPayment();
		if (response.meta.code !== 200 || !response.data.payment || response.data.payment.status !== 'active') {
			window.location.replace(`/?shop=${queryObject.shop}`);
			return;
		}

		window.location.replace('/dashboard/emails/settings/general');
		return;
		/* Legacy Implementation
		const response = await CHATED.payment.activatePayment(paymentId);

		switch (response.meta.code) {
			case 200:
				dispatch({
					type: ACTIVATE_PAYMENT,
					meta: response.meta,
					redirect_url: '/callback/payment/success?page=' // TODO - url for the service eg. /dashboard/whitelabel, /dashboard/multiple-emails
				});
				break;
			case 42000:
			default:
				dispatch({
					type: ERROR_ACTIVATE_PAYMENT,
					meta: response.meta,
					redirect_url: '/callback/payment/fail?page=' // TODO - url for the service eg. /dashboard/whitelabel, /dashboard/multiple-emails
				});
				break;
		}
		*/
	};
}



// WEBPACK FOOTER //
// ./src/containers/callback-payment-page/actions/index.js